export type HighlightPart = {
  text: string
  hit: boolean
}

export function foldSearch(value: string) {
  return String(value || '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/ș|ş/gi, 's')
    .replace(/ț|ţ/gi, 't')
    .toLowerCase()
}

export function searchTokens(query: string) {
  return foldSearch(query)
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter((token) => token.length >= 2)
}

function foldWithMap(value: string) {
  const original = String(value || '')
  let folded = ''
  const map: number[] = []
  for (let i = 0; i < original.length; i += 1) {
    const piece = foldSearch(original[i])
    for (let j = 0; j < piece.length; j += 1) {
      folded += piece[j]
      map.push(i)
    }
  }
  return { folded, map }
}

export function highlightParts(text: string, query: string): HighlightPart[] {
  const source = String(text || '')
  const tokens = searchTokens(query)
  if (!source) return []
  if (!tokens.length) return [{ text: source, hit: false }]

  const { folded, map } = foldWithMap(source)
  const ranges: [number, number][] = []
  for (const token of tokens) {
    let from = 0
    while (from < folded.length) {
      const found = folded.indexOf(token, from)
      if (found < 0) break
      const start = map[found]
      const end = (map[found + token.length - 1] ?? start) + 1
      ranges.push([start, end])
      from = found + Math.max(token.length, 1)
    }
  }
  if (!ranges.length) return [{ text: source, hit: false }]

  ranges.sort((a, b) => a[0] - b[0] || a[1] - b[1])
  const merged: [number, number][] = []
  for (const range of ranges) {
    const last = merged[merged.length - 1]
    if (last && range[0] <= last[1]) {
      last[1] = Math.max(last[1], range[1])
    }
    else {
      merged.push([range[0], range[1]])
    }
  }

  const parts: HighlightPart[] = []
  let cursor = 0
  for (const [start, end] of merged) {
    if (start > cursor) parts.push({ text: source.slice(cursor, start), hit: false })
    if (end > start) parts.push({ text: source.slice(start, end), hit: true })
    cursor = Math.max(cursor, end)
  }
  if (cursor < source.length) parts.push({ text: source.slice(cursor), hit: false })
  return parts
}

export function searchHitWhere(field?: string) {
  if (field === 'title') return 'în titlu'
  if (field === 'sku') return 'în SKU'
  if (field === 'model') return 'în model'
  if (field === 'brand') return 'în brand'
  if (field === 'category') return 'în categorie'
  if (field === 'color') return 'în culoare'
  if (field === 'storage') return 'în stocare'
  if (field === 'subtitle') return 'în descriere'
  if (field === 'content') return 'în text'
  return ''
}
